import { Trans } from '@lingui/react/macro'
import { Text } from 'designSystem/components/Text'
import type { ReactElement } from 'react'

type LotoSaveStatusTextProps = {
  saving: boolean
  failed: boolean
  hasChanges: boolean
}

function StatusLabel({
  saving,
  failed,
  hasChanges,
}: LotoSaveStatusTextProps): ReactElement | null {
  if (saving) return <Trans>Saving…</Trans>
  if (failed)
    return (
      <Text as='span' variant='caption' color='destructive'>
        <Trans>Couldn’t save</Trans>
      </Text>
    )
  if (hasChanges) return <Trans>Unsaved changes</Trans>
  return null
}

export function LotoSaveStatusText(
  props: LotoSaveStatusTextProps
): ReactElement {
  return (
    <Text as='span' variant='caption' color='muted' role='status' truncate>
      <StatusLabel {...props} />
    </Text>
  )
}
